/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener('DOMContentLoaded', function() {
  /* Product page availability */
  const availabilityContainer = document.querySelector('.product-meta__meta-store-availability-container ');
  if (availabilityContainer) {
    availabilityContainer.querySelector('.card__collapsible-mask').addEventListener('click', function() {
      document.dispatchEvent(new CustomEvent('collapsible:toggle', {
        detail: {
          id: 'unique-tab-availability'
        }
      }));
    });
  }

  /* collection tabs */
  const collectionHighlightSections = document.querySelectorAll('.section-collection-highlight');
  if (collectionHighlightSections && collectionHighlightSections.length > 0) {
    collectionHighlightSections.forEach(function(section) {
      const collectionTabs = section.querySelectorAll('.collection-highlight-tabs__tab');
      collectionTabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          const target = this.dataset.handle;
          if (this.classList.contains('collection-highlight-tabs__tab--active')) {
            return;
          }

          const activeTab = section.querySelector('.collection-highlight-tabs__tab--active');
          const activeContent = section.querySelector('.collection-highlight-item--active');
          const targetContent = section.querySelector('.collection-highlight-item__' + target);

          if (targetContent.classList.contains('collection-tab-item--active')) {
            return;
          }

          activeTab.classList.remove('collection-highlight-tabs__tab--active');
          activeContent.classList.remove('collection-highlight-item--active');

          this.classList.add('collection-highlight-tabs__tab--active');
          targetContent.classList.add('collection-highlight-item--active');
        });
      });
    });
  }

  /* collection tabs */
  const collectionTabSections = document.querySelectorAll('.section-collection-tabs');
  if (collectionTabSections && collectionTabSections.length > 0) {
    collectionTabSections.forEach(function(section) {
      const collectionTabs = section.querySelectorAll('.collection-tabs__tab');
      collectionTabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          const target = this.dataset.handle;
          if (this.classList.contains('collection-tabs__tab--active')) {
            return;
          }

          const activeTab = section.querySelector('.collection-tabs__tab--active');
          const activeContent = section.querySelector('.collection-tab-item--active');
          const targetContent = section.querySelector('.collection-tab-item__' + target);

          if (targetContent.classList.contains('collection-tab-item--active')) {
            return;
          }

          activeTab.classList.remove('collection-tabs__tab--active');
          activeContent.classList.remove('collection-tab-item--active');

          this.classList.add('collection-tabs__tab--active');
          targetContent.classList.add('collection-tab-item--active');
        });
      });
    });
  }

  /* bundle landing page collection tabs */
  const bundleLandingSection = document.querySelector('.section-bundle-landing');
  if (bundleLandingSection) {
    const section = bundleLandingSection;
    const qsKey = 'collection';
    const qsValue = (new URLSearchParams(location.search)).get(qsKey);
    const tab = section.querySelector(`.collection-tabs__tab[data-handle="${qsValue}"]`) || section.querySelector('.collection-tabs__tab');
    const collection = tab.dataset.handle;
    tab.classList.add('collection-tabs__tab--active');

    let state = {
      handle: collection,
    };
    async function refreshProductList() {
      section.classList.add('loading');
      // scroll to collections tab after old product list is hidden
      section.querySelector('.collection-tabs__header').scrollIntoView({behavior: "auto", block: "nearest", inline: "nearest"});
      const oldState = {
        ...state
      };
      const html = await fetch(`${routes.collectionsUrl}/${state.handle}?section_id=collection-template`).then(r => r.text());
      const isSameState = Object.keys(oldState).map(k => oldState[k] === state[k]).every(Boolean);
      if (isSameState) {
        section.querySelector('.collection-tabs .scroller__inner').innerHTML = html;
        document.documentElement.dispatchEvent(new CustomEvent('collection:refresh', {
          bubbles: true,
        }));

        section.classList.remove('loading');
      }
    }
    refreshProductList();
    const collectionTabs = section.querySelectorAll('.collection-tabs__tab');
    collectionTabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        const target = this.dataset.handle;
        if (state.handle === target) {
          return;
        }

        state.handle = target;
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(qsKey, target);
        const newUrl = `${location.pathname}?${searchParams.toString()}${ location.hash ? `#${location.hash}` : ''}`;
        history.pushState(history.state, '', newUrl);

        const activeTab = section.querySelector('.collection-tabs__tab--active');
        activeTab.classList.remove('collection-tabs__tab--active');
        this.classList.add('collection-tabs__tab--active');

        refreshProductList();
      });
    });
  }

  /* meta tabs */
  const productMetaTabs = document.querySelectorAll('.product-meta-tab');
  if (productMetaTabs && productMetaTabs.length > 0) {
    productMetaTabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        const target = this.dataset.metaContent;
        if (this.classList.contains('product-meta-content--active')) {
          return;
        }

        const activeTab = document.querySelector('.product-meta-tab--active');
        const activeContent = document.querySelector('.product-meta-content--active');
        const targetContent = document.querySelector('.product-meta-content__' + target);

        if (targetContent.classList.contains('product-meta-content--active')) {
          return;
        }

        activeTab.classList.remove('product-meta-tab--active');
        activeContent.classList.remove('product-meta-content--active');

        this.classList.add('product-meta-tab--active');
        targetContent.classList.add('product-meta-content--active');
      });
    });
  }
  const reviewsLink = document.querySelectorAll('.product-meta__reviews-badge.link');
  if (reviewsLink && reviewsLink.length > 0) {
    reviewsLink.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const activeTab = document.querySelector('.product-meta-tab--active');
        const activeContent = document.querySelector('.product-meta-content--active');
        const targetTab = document.querySelector('.product-meta-tab[data-meta-content=reviews]');
        const targetContent = document.querySelector('.product-meta-content__reviews');
        
        
        if (targetContent.classList.contains('product-meta-content--active')) {
          return;
        }

        activeTab.classList.remove('product-meta-tab--active');
        activeContent.classList.remove('product-meta-content--active');

        targetTab.classList.add('product-meta-tab--active');
        targetContent.classList.add('product-meta-content--active');
      });
    });
  }

  /* frequently bought together */
  const fbt = document.querySelectorAll('.section-frequently-bought-together');
  if (fbt && fbt.length > 0) {
    fbt.forEach(function(el) {
      const selects = el.querySelectorAll('.fbt__option-checkbox');

      function recalculatePrice() {
        var count = 0, price = 0;
        for (var i = 0; i < selects.length; i++) {
          const select = selects[i];
          if (select.checked) {
            count++;
            price += parseInt(select.dataset.price);
          }
        }
        el.querySelector('.fbt__price-block .price').innerHTML = Shopify.formatMoney(price, window.theme.moneyFormat);

        /*
        if (count == selects.length) {
          el.querySelector('.fbt__price-block .fbt__cta .count').innerHTML = 'all';
        } else {
          el.querySelector('.fbt__price-block .fbt__cta .count').innerHTML = count;
        }
        */
      }

      selects.forEach(function(select) {
        select.addEventListener('click', function(e) {
          const variantId = this.dataset.variantId;
          const imageWrapper = el.querySelector('.fbt__image-wrapper-' + variantId);
          if (!this.checked) {
            imageWrapper.classList.add('fbt__image-wrapper--inactive');
          } else {
            imageWrapper.classList.remove('fbt__image-wrapper--inactive');
          }
          setTimeout(function() {
            recalculatePrice();
          }, 0);
        });
      });

      el.querySelector('.fbt__cta').addEventListener('click', function() {
        var items = [];
        const options = el.querySelectorAll('.fbt__option');
        for (var i = 0; i < options.length; i++) {
          const option = options[i];

          items.push({
            id: parseInt(option.dataset.variantId),
            quantity: 1
          });
        }

        const data = {
          items: items
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(function(response) {
          window.location.href = window.routes.rootUrlWithoutSlash + '/cart';
        })
        .catch(function(error) {
          console.log(error);
        });
      });
    });
  }

  /* Metafields variants store availability in product page */
  document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant; // Gives you access to the whole variant details
    const containers = document.querySelectorAll('.availability-container');
    if (containers && containers.length > 1) {
      containers.forEach(function(el) {
        if (parseInt(el.dataset.variantId) === parseInt(variant.id)) {
          el.classList.add('availability-container--active');
        } else {
          el.classList.remove('availability-container--active');
        }
      });
    }
  });
});

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function calculateProductItemsDiscountedPointsEarned(event = {}) {
  const _event = event;
  const hasDiscounts = document.querySelectorAll('.product-item__earn-rewards.loading-earn-rewards').forEach(function(el) {
    const item = el.closest('.product-item');
    
    console.log(item);
    
    function handleDiscounts() {
      if (!el.classList.contains('loading-earn-rewards')) return;
      
      const jrewardsRatio = window.earnPointsRatio.jrewardsRatio;
      const jrewardsMultiplier = item.dataset.jrewardsMultipler || 1;
      const asiaMilesRatio = window.earnPointsRatio.asiaMilesRatio;
      const asiaMilesMultiplier = item.dataset.asiaMilesMultipler || 1;

      let price;
      
      if (event.detail && event.detail.selling_price) {
        price = event.detail.selling_price;
      } else if (item.querySelector('.geolizr-currency')) {
        price = item.querySelector('.geolizr-currency').dataset.geolizrPrice;
      }

      if (price) {
        const jrewardsItem = item.querySelector('.product-item__jrewards-item');
        if (jrewardsItem) {
          jrewardsItem.querySelector('span').innerHTML = numberWithCommas(Math.floor(price * jrewardsMultiplier / jrewardsRatio / 100));
        }

        const asiaMilesItem = item.querySelector('.product-item__asiamiles-item');
        if (asiaMilesItem) {
          asiaMilesItem.querySelector('span').innerHTML = numberWithCommas(Math.floor(price * asiaMilesMultiplier / asiaMilesRatio / 100));
        }
        el.classList.remove('loading-earn-rewards');
      }
    }

    setTimeout(function() {
      if (el.classList.contains('loading-earn-rewards')) handleDiscounts(_event);
    }, 2500);
    setTimeout(function() {
      if (el.classList.contains('loading-earn-rewards')) handleDiscounts(_event);
    }, 4000);
  });
}
calculateProductItemsDiscountedPointsEarned();
document.addEventListener('theme:loading:end', calculateProductItemsDiscountedPointsEarned);

function refreshProductMetaPointsEarned(event = {}) {
  const _event = event;
  document.querySelectorAll('.product-meta__earn-rewards.loading-earn-rewards').forEach(function(el) {
    const item = el.closest('.product-meta');
    const _this = this;
    
    function refreshPoints(event) {
      if (!el.classList.contains('loading-earn-rewards')) return;
      
      const jrewardsRatio = window.earnPointsRatio.jrewardsRatio;
      const jrewardsMultiplier = el.dataset.jrewardsMultiplier || 1;
      const asiaMilesRatio = window.earnPointsRatio.asiaMilesRatio;
      const asiaMilesMultiplier = el.dataset.asiaMilesMultiplier || 1;
      
      if (event.detail && event.detail.selling_price) {
        price = event.detail.selling_price;
      } else {
        price = item.querySelector('.geolizr-currency').dataset.geolizrPrice;
      }
      
      if (price) {
        const jrewardsItem = item.querySelector('.product-meta__jrewards-item');
        if (jrewardsItem) {
          jrewardsItem.querySelector('span').innerHTML = numberWithCommas(Math.floor(price * jrewardsMultiplier / jrewardsRatio / 100));
        }

        const asiaMilesItem = item.querySelector('.product-meta__asiamiles-item');
        if (asiaMilesItem) {
          asiaMilesItem.querySelector('span').innerHTML = numberWithCommas(Math.floor(price * asiaMilesMultiplier / asiaMilesRatio / 100));
        }
        el.classList.remove('loading-earn-rewards');
      } else {
        console.log('=> not found');
      }
    }
  
    setTimeout(function() {
      if (el.classList.contains('loading-earn-rewards')) refreshPoints(_event);
    }, 200);
    setTimeout(function() {
      if (el.classList.contains('loading-earn-rewards')) refreshPoints(_event);
    }, 300);
    setTimeout(function() {
      el.classList.remove('loading-earn-rewards');
    }, 310);
  });
}

setTimeout(function() {
  refreshProductMetaPointsEarned();
}, 3100);

document.addEventListener('variant:changed', function(event) {
  const earnRewards = document.querySelectorAll('.product-meta__earn-rewards');
  const variant = event.detail.variant;

  earnRewards.forEach(function(el) {
    el.classList.add('loading-earn-rewards');
  });
  setTimeout(function() {
  	refreshProductMetaPointsEarned(event);
  }, 500);
});


function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
var resetMosaicText = debounce(function () {
  var contents = document.querySelectorAll(".promo-block__content");
  for (const content of contents) {
    var parent = content.parentNode;
    const ps = getComputedStyle(parent);
    let height = parent.clientHeight - parseFloat(ps.paddingBottom) - parseFloat(ps.paddingTop);
    for (const child of parent.childNodes) {
      if (child == content) {
        continue;
      }
      height -= child.offsetHeight;
    }
    const lines = Number(height / 24.31);
    content.style['-webkit-line-clamp'] = Math.floor(lines);
  }

}, 250);

if (document.getElementsByClassName("promo-block__content").length > 0) {
  window.addEventListener("load", resetMosaicText);
  window.addEventListener("resize", resetMosaicText);
}

/** Coupon section **/
(function() {
  document.querySelectorAll('[data-section-type=coupon-section]').forEach((container) => {
    const countdown = container.querySelector('.coupon-section__countdown');
    if (countdown) {
      var fullDate = countdown.dataset.endDate;
      var arr = fullDate.split(/[- :]/);
      var endDate = (new Date(arr[0], arr[1]-1, arr[2], arr[3] || 0, arr[4] || 0)).valueOf();
      
      const seconds = container.querySelector('[data-countdown=seconds]');
      const minutes = container.querySelector('[data-countdown=minutes]');
      const hours = container.querySelector('[data-countdown=hours]');
      const days = container.querySelector('[data-countdown=days]');
      
      const counter = setInterval(() => {
        updateTimer();
      }, 1000);
    
      function updateTimer() {
        if (isNaN(endDate)) {
          fullDate = countdown.dataset.endDate;
          arr = fullDate.split(/[- :]/);
          endDate = (new Date(arr[0], arr[1]-1, arr[2], arr[3] || 0, arr[4] || 0)).valueOf();
          return;
        }
        
        const now = (new Date()).valueOf(), d = endDate - now;
        
        if (d > 0) {
          seconds.innerHTML = Math.floor(d / 1000) % 60;
          minutes.innerHTML = Math.floor(d / 60000) % 60;
          hours.innerHTML = Math.floor(d / 3600000) % 24;
          days.innerHTML = Math.floor(d / 86400000);
        } else {
          clearInterval(updateTimer);
          countdown.closest('.shopify-section').style.display = 'none';
        }
      }
    }
    
    const coupons = container.querySelectorAll('.coupon-section__copy-code-button');
    coupons.forEach((el) => {
      const code = el.querySelector('.coupon-section__coupon-code');
      el.addEventListener('click', (e) => {
        code.focus();
        code.select();
        try {
          document.execCommand('copy');
        } catch (e) {
          console.log('Oops, cannot copy!', e);
        }
        code.blur();
        
        el.dataset.tooltip = 'Copied!';
        
        setTimeout(() => {
          delete el.dataset.tooltip;
        }, 3000);
      });
      
      code.addEventListener('change', (e) => {
        code.value = el.dataset.code;
      });
    });
  });
})();

async function getProductQuotaJson(handle) {
  const resp = await fetch(`${window.routes.rootUrlWithoutSlash}/products/${handle}?view=quota-json`);
  // Draft product with redirection case
  if (resp.redirected) {
    return {
      "has_limit": false
    };
  }
  return resp.json();
}

/** MDA products **/
(function() {
  function buildMDACart() {
    const values = {
      zh: { yes: '需要', no: '不需要'},
      en: { yes: 'Required', no: 'Not required'},
    };
    const selects = document.querySelectorAll('.line-item__mda-select');
    
    function validateMDAProperties() {
      var valid = true;
      selects.forEach(el => {
        if (!el.value) valid = false;
      });
      if (valid) {
        document.querySelectorAll('.checkout-button-wrap').forEach(el => {
          el.classList.remove('mda-disabled');
        });
      } else {
        document.querySelectorAll('.checkout-button-wrap').forEach(el => {
          el.classList.add('mda-disabled');
        });
      }
    }
    
    async function changeMDALineItemProperties(lineItemData) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(lineItemData)
      })
      .then(function(response) {
        // console.log('Updated MDA properties', response);
      })
      .catch(function(error) {
        console.log(error);
      });
    }
    
    async function updateMDANoteAttributes() {
      const arrSelects = [...selects];
      const noteAttributesData = {
        attributes: {
          'Removal option SKU': arrSelects.map(el => el.dataset.sku).join(','),
          'Removal option': arrSelects.map(el => values.en[el.value]).join(','),
        }
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(noteAttributesData)
      })
      .then(function(response) {
        // console.log('Updated MDA attributes', response);
      })
      .catch(function(error) {
        console.log(error);
      });
    }
    
  	validateMDAProperties();
    selects.forEach(el => {
      el.addEventListener('change', async () => {
        const index = el.dataset.index;
        const lineItemData = {
          line: index,
          properties: {
            '棄置電器除舊服務': values.zh[el.value],
            'Waste Appliance Removal Services': values.en[el.value],
          }
        };
                          
		Promise.all([
          changeMDALineItemProperties(lineItemData),
          updateMDANoteAttributes(),
        ]).then(v => {
          validateMDAProperties();
        });
      });
      el.removeAttribute('disabled');
    });
  }
  
  document.addEventListener('cart:refresh', buildMDACart);
  document.addEventListener('cart:rerendered', buildMDACart);
  buildMDACart();
})();